/* eslint-disable no-loop-func */
import moment from 'moment';
import {
  defaultClient as apolloClient,
} from '@/plugins/vue-apollo';
import { isBulkTransactionsEnabled } from '@/utils/bulkTransactionsHelper';
import {
  GET_CATEGORY_EXPENSE_CALCULATION_CARD,
  GET_TEAM_TO_USERS_GQL,
} from '@/graphql/queries.gql';
import {
  UPDATE_USER_EXPENSE_GQL,
  GET_USER_ALL_TRANSACTIONS,
  GET_USER_GROUP_CATEGORIES_GQL_NEW,
  GET_CATEGORY_NAME_GQL,
  GET_TEAM_SPENT_TRANSACTIONS,
  GET_CATEGORY_SPENT_TRANSACTION,
  GET_UN_CATEGORIZED_TRANSACTIONS,
  GET_UN_CATEGORIZED_FOR_TAB,
  GET_UN_CATEGORIZED_TRANSACTIONS_1,
  GET_ALL_TRANSACTIONS,
  UPDATE_QB_TRANSACTION,
  GET_TRANSACTIONS_BY_COMPANY,
  MAP_MERCHANT_TO_CATEGORY_GQL,
  GET_MAP_MERCHANT_TO_CATEGORY_GQL,
  GET_MAP_ALL_MERCHANT_TO_TEAM_GQL,
  GET_TEAMS_COMPANY,
  SET_COMPANY_TEAM_CATEGORY,
  REMOVE_TRANSACTION,
  GET_DASHBOARD_TRANSACTION,
  CREATE_CATEGORY_TO_USER,
  SPLIT_TRANSACTIONS,
  GET_SINGLE_TRANSACTION,
  DELETE_SPLIT_TRANSACTION,
  DELETE_EXT_TRANSACTIONS,
  // UPDATE_TRANSACTION,
  CREATE_CATEGORY_BY_XLS,
  CREATE_TAG_BY_XLS,
  CREATE_TEAMS_BY_XLS,
  GET_XLS_TRANSACTION,
  GET_XLS_TRANSACTION_TEAM,
  GET_XLS_TRANSACTION_TAG,
  STORE_TRANSCREEN_COL_SEL_IN_DB_GQL,
  SET_NULL_TEAM_CATEGORY,
  SET_PERFORM_BULK_CATEGORIZATION_GQL,
  GET_TEAMS_COMPANY_LIST,
  GET_MOVE_TRANSACTION_HISTORY,
  DOWNLOAD_TRANSACTION_IN_PDF,
  GET_UN_CATEGORIZED_MY_TRANSACTION,
  GET_ALL_MY_TRANSACTIONS,
  GET_RECEIPT_LINKS,
} from '@/graphql/transactions.gql';
import router from '@/router';


const AWS = require('aws-sdk');

export default {
  namespaced: true,

  state: {
    // = data
    xlsFileUpload: null,
    selectedTransactions: [],
    receiptData: null,
    receiptUrl: [],
    getUserCategories: [],
    getWithoutUserCategories: [],
    getCatTransaction: [],
    getPendingTransaction: [],
    flaggedTransaction: [],
    getCategoryName: null,
    transactionMyTeam: [],
    declinedTransaction: [],
    approvedTransaction: [],
    clearedTransaction: [],
    getTeamBudget: [],
    getCategoryBudget: [],
    categoryBudgetCalculation: [],
    teamSpentTransactions: [],
    teamSpendBudgetAmount: [],
    categorySpentTransaction: [],
    unCategorizedTransaction: [],
    unCategorizedTransactions: [],
    categoryForGroup: [],
    categoryForGroupWithoutUser: [],
    userRoleForTeam: [],
    userSpentAmount: null,
    filterByName: '',
    qbSyncStatus: null,
    getCompanyAllTransactions: [],
    factorWiseSum: null,
    isDateRanges: false,
    mapMerchantToCategory: [],
    mapMerchantToCategorygroup: [],
    mapMerchantToCategorygroupTime: null,
    selectedTeams: [],
    teamsForAllCompany: [],
    selectedALLTeams: [],
    companyForAutoCategorization: [],
    moveTransactions: null,
    removeTransactions: null,
    unCategorizeDashboard: [],
    gotoCardData: null,
    splitTransactionsSet: null,
    singleTransactions: null,
    isAmountValid: false,
    deletedTrans: null,
    myInlineTransaction: [],
    myDeleteTransaction: [],
    setTableColumn: [],
    approvedTransactionStatus: null,
    setTabName: 0,
    downloadXLSdata: [],
    downloadXLSdataTeam: [],
    downloadXLSdataTag: [],
    performBulkCategorizationRes: null,
    moveTransactionsHistory: [],
    setNullValueTeam: null,
    allUncategorize: [],
    teamsForBulkCategorization: [],
  },

  mutations: {
    SET_XLS_FILE(state, payload) {
      state.xlsFileUpload = payload;
    },
    SET_SELECTED_TRANSACTIONS(state, payload) {
      state.selectedTransactions = payload;
    },
    REMOVE_DELETE_TRANS(state, payload) {
      state.deletedTrans = payload;
    },
    REMOVE_CATEGORY_TRANSACTION(state, payload) {
      state.removeTransactions = payload;
    },
    MOVE_CATEGORY_TRANSACTION(state, payload) {
      state.moveTransactions = payload;
    },
    SET_MY_TEAMS(state, payload) {
      state.transactionMyTeam = payload;
    },
    SET_UPDATE_USER_EXPENSE(state, payload) {
      state.receiptData = payload;
    },
    SET_PENDING_TRANSACTIONS(state, payload) {
      state.getPendingTransaction = payload;
    },
    SET_FLAGGED_TRANSACTIONS(state, payload) {
      state.flaggedTransaction = payload;
    },
    SET_RECEIPT_URL(state, payload) {
      state.receiptUrl = payload;
    },
    SET_CATEGORY_FOR_USER(state, payload) {
      state.getUserCategories = payload;
    },
    // SET_CATEGORY_FOR_WITHOUGHT_USER(state, payload) {
    //   state.getWithoutUserCategories = payload;
    // },
    SET_TRANSACTIONS(state, payload) {
      state.getCatTransaction = payload;
    },
    SET_DECLINED_TRANSACTION(state, payload) {
      state.declinedTransaction = payload;
    },
    SET_APPROVED_TRANSACTION(state, payload) {
      state.approvedTransaction = payload;
    },
    SET_CLEARED_TRANSACTION(state, payload) {
      state.clearedTransaction = payload;
    },
    SET_CATEGORY_NAME(state, payload) {
      state.getCategoryName = payload;
    },
    SET_TEAMWISE_EXPENCE_CARD(state, payload) {
      state.getTeamBudget = payload;
    },
    SET_CATEGORYWISE_EXPENCE_CARD(state, payload) {
      state.getCategoryBudget = payload;
    },
    SET_CATEGORY_BUDGET_CALCULATION(state, payload) {
      state.categoryBudgetCalculation = payload;
    },
    SET_TEAM_SPENT_TRANSACTIONS(state, payload) {
      state.teamSpentTransactions = payload;
    },
    SET_TEAM_SPENT_BUDGET(state, payload) {
      state.teamSpendBudgetAmount = payload;
    },
    SET_CATEGORY_SPENT_TRANSACTIONS(state, payload) {
      state.categorySpentTransaction = payload;
    },
    SET_UNCATEGORY_SPENT_TRANSACTION(state, payload) {
      state.unCategorizedTransaction = payload;
    },
    SET_UNCATEGORY_SPENT_TRANSACTIONS(state, payload) {
      state.unCategorizedTransactions = payload;
    },
    SET_ALL_UNCATEGORIZED_TRANSACTIONS(state, payload) {
      state.allUncategorize = payload;
    },
    SET_CATEGORY_FOR_USER_TRANSACTION(state, payload) {
      state.categoryForGroup = payload;
    },
    SET_CATEGORY_FOR_USER_TRANSACTION_2(state, payload) {
      state.categoryForGroupWithoutUser = payload;
    },
    SET_USER_ROLE_TEAM(state, payload) {
      state.userRoleForTeam = payload;
    },
    SET_USER_SPENT_AMOUNT(state, payload) {
      state.userSpentAmount = payload;
    },
    SET_FILTER_ALL_TRANSACTIONS(state, payload) {
      state.filterByName = payload;
    },
    SET_QB_SYNC_STATUS(state, payload) {
      state.qbSyncStatus = payload;
    },
    GET_COMPANY_ALL_TRANSACTION(state, payload) {
      state.getCompanyAllTransactions = payload;
    },
    SET_SUM_OF_FACTOR_WISE(state, payload) {
      state.factorWiseSum = payload;
    },

    SET_DATE_RANGE(state, payload) {
      state.isDateRanges = payload;
    },

    SET_MERCHANT_TO_CATEGORY_RANGE(state, payload) {
      state.mapMerchantToCategory = payload;
    },

    SET_MERCHANT_TO_CATEGORY_GROUP(state, payload) {
      state.mapMerchantToCategorygroup = payload;
    },

    SET_MERCHANT_TO_CATEGORY_GROUP_TIME(state, payload) {
      state.mapMerchantToCategorygroupTime = payload;
    },
    SET_TEAMS(state, payload) {
      state.selectedTeams = payload;
    },

    SET_TEAMS_ALL_COMPANY(state, payload) {
      state.selectedALLTeams = payload;
    },
    SET_AUTO_CATEGORISE(state, payload) {
      state.companyForAutoCategorization = payload;
    },
    SET_DASHBOARD_TRANSACTION(state, payload) {
      state.unCategorizeDashboard = payload;
    },

    SET_TRANSACTIONS_DATA(state, payload) {
      state.gotoCardData = payload;
    },

    SET_TRANSACTIONS_SPIT_VALUE(state, payload) {
      state.splitTransactionsSet = payload;
    },
    SET_SINGLE_TRANSACTION(state, payload) {
      state.singleTransactions = payload;
    },
    IS_VALIDATE_AMOUNT(state, payload) {
      state.isAmountValid = payload;
    },
    SET_INLINE_TRANSACTIONS(state, payload) {
      state.myInlineTransaction = [];
      state.myInlineTransaction = payload;
    },
    REMOVE_INLINE_TRANSACTIONS(state, payload) {
      state.myDeleteTransaction = payload;
    },
    SET_TABLE_COLUMN(state, payload) {
      state.setTableColumn = payload;
    },
    SET_APPROVED_TRANSACTION_STATUS(state, payload) {
      state.approvedTransactionStatus = payload;
    },
    SET_TAB_NAME(state, payload) {
      if (payload > 7) {
        state.setTabName = 0;
      } else {
        state.setTabName = payload;
      }
    },
    SET_DOWNLOAD_XLS_FILE(state, payload) {
      state.downloadXLSdata = payload;
    },
    SET_DOWNLOAD_XLS_FILE_TEAM(state, payload) {
      state.downloadXLSdataTeam = payload;
    },
    SET_DOWNLOAD_XLS_FILE_TAG(state, payload) {
      state.downloadXLSdataTag = payload;
    },
    SET_PERFORM_BULK_CATEGORIZATION(state, payload) {
      state.performBulkCategorizationRes = payload;
    },
    SET_MOVE_TRANSACTION_HISTORY(state, payload) {
      state.moveTransactionsHistory = payload;
    },
    SET_NULL_VALUE_FOR_TRANSACTIONS(state, payload) {
      state.setNullValueTeam = payload;
    },

    SET_TEAMS_FOR_BULK_CATEGORIZATION(state, payload) {
      state.teamsForBulkCategorization = payload;
    },
  },
  actions: {
    async setNullTeam({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_NULL_TEAM_CATEGORY,
          variables: {
            id: payload.id,
          },
        })
        .then((setNullTeamdata) => {
          commit('SET_NULL_VALUE_FOR_TRANSACTIONS', setNullTeamdata.data.updateUserExpenseNullTeam);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async isValidAmount({ commit }, payload) {
      commit('IS_VALIDATE_AMOUNT', payload);
    },

    async categorizeTransaction({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_USER_EXPENSE_GQL,
          variables: {
            id: payload.expenseId,
            categoryId: payload.categoryId,
            groupId: payload.groupId,
            tagAction: payload.tagAction,
            categorizationDate: moment().format(),
          },
        })
        .then((categorizeTransactiondata) => {
          commit('SET_UPDATE_USER_EXPENSE', categorizeTransactiondata.data.updateUserExpense);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((cterr) => {
          console.log(cterr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async receiptUpload({ commit }, payload) {
      const { splitMyTransaction, deleteMySplitTransactions, value } = payload;

      if (splitMyTransaction) {
        // split the transaction
        if (splitMyTransaction.length >= 1) {
          splitMyTransaction.forEach((item) => {
            item.amount = parseFloat(item.amount);
            delete item.accountingTransaction;
            delete item.agillinkTransaction;
          });
          await apolloClient
            .mutate({
              mutation: SPLIT_TRANSACTIONS,
              variables: {
                splitData: splitMyTransaction,
                originalAmount: value.originalAmount,
                originalId: value.id,
                splitId: value.splitId,
              },
            })
            .then((receiptUploaddata) => {
              commit('SET_TRANSACTIONS_SPIT_VALUE', receiptUploaddata.data.splitTransactions);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((ruerr) => {
              console.log(ruerr);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }
      }
      if (deleteMySplitTransactions) {
        if (deleteMySplitTransactions.length) {
          await apolloClient
            .mutate({
              mutation: DELETE_SPLIT_TRANSACTION,
              variables: {
                deleteData: deleteMySplitTransactions,
              },
            }).then(() => {
              // this is default
            }).catch((err) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(err);
            });
        }
      }


      const updateUserExp = {
        description: payload.description ? payload.description : null,
        id: payload.id,
        categoryId: payload.categoryId ? payload.categoryId : null,
        groupId: payload.groupId ? payload.groupId : null,
        receipts: [],
        companyId: payload.selectedCompany,
        qbSyncStatus: payload.qbSyncStatus,
        expenseReceiptsTodelete: payload.expenseReceiptsTodelete,
        tagAction: payload.tagAction,
        tagId: payload.tagId,
        prevTag: payload.prevTag,
      };

      let files = [];
      if (payload.reciepts) {
        files = payload.reciepts;
      }


      const BUCKET_NAME = process.env.VUE_APP_RECEIPT_BUCKET_NAME;
      const IAM_USER_KEY = process.env.VUE_APP_AWS_IAM_USER_KEY;
      const IAM_USER_SECRET = process.env.VUE_APP_AWS_IAM_USER_SECRET;

      const s3bucket = new AWS.S3({
        accessKeyId: IAM_USER_KEY,
        secretAccessKey: IAM_USER_SECRET,
        Bucket: BUCKET_NAME,
      });
      const usrObj = payload.userId;

      for (let i = 0; i < files.length; i += 1) {
        if (files[i].fileSelected) {
          const promise = new Promise((async (resolve) => {
            const itemFile = files[i];
            const fileName = itemFile.fileSelected.name;
            const type = fileName.split('.').pop();
            const timeStamp = Date.now();
            let contentType = '';
            if (type === 'pdf') {
              contentType = 'application/pdf';
            } else {
              contentType = `image/${type}`;
            }
            const newFileName = `${timeStamp}.${type}`;
            const objkey = `${usrObj}/${newFileName}`;
            const contentDeposition = `inline;filename="${objkey}"`;

            s3bucket.createBucket(async () => {
              const params = {
                Bucket: BUCKET_NAME,
                Key: objkey,
                Body: itemFile.fileSelected.raw,
                ContentDisposition: contentDeposition,
                ContentType: contentType,
              };

              await s3bucket.upload(params, async (err, data) => {
                if (err) {
                  console.log(err);
                }
                const receipt = {
                  link: data.Location,
                  recordStatus: 1,
                  title: fileName,
                };
                  // eslint-disable-next-line no-undef
                updateUserExp.receipts.push(receipt);
                resolve(receipt);
              });
            });
          }));

          // eslint-disable-next-line no-await-in-loop
          await Promise.all([promise]).then(() => {
            // this is default
          });
        } // if
      } // For Loop Over

      //  if have same company;
      if (payload.selectedCompany === payload.originCompany) {
        apolloClient
          .mutate({
            mutation: UPDATE_USER_EXPENSE_GQL,
            variables: {
              description: updateUserExp.description,
              id: updateUserExp.id,
              categoryId: updateUserExp.categoryId,
              groupId: updateUserExp.groupId,
              expenseReceipts: updateUserExp.receipts,
              qbSyncStatus: updateUserExp.qbSyncStatus,
              expenseReceiptsTodelete: updateUserExp.expenseReceiptsTodelete,
              tagId: updateUserExp.tagId,
              tagAction: updateUserExp.tagAction,
              prevTag: updateUserExp.prevTag,
            },
          })
          .then((selecteddata) => {
            commit('SET_UPDATE_USER_EXPENSE', selecteddata.data.updateUserExpense);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((selectederr) => {
            console.log(selectederr);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
      }

      // if not then Cross Company will  be applied;
      if (payload.selectedCompany !== payload.originCompany) {
        // Send Data;
        await apolloClient
          .mutate({
            mutation: SET_COMPANY_TEAM_CATEGORY,
            variables: {
              ...updateUserExp,
            },
          })
          .then((originCompanydata) => {
            commit('SET_UPDATE_USER_EXPENSE', originCompanydata.data.moveCompanyTransactions);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((originCompanydataerr) => {
            console.log('err', originCompanydataerr);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
      }
      if (payload.qbSyncId !== '' && payload.qbSyncId !== undefined) {
        apolloClient
          .mutate({
            mutation: UPDATE_QB_TRANSACTION,
            variables: { id: payload.qbSyncId, qbSyncStatus: 2 },
          })
          .then((qbSyncIddata) => {
            commit('SET_QB_SYNC_STATUS', qbSyncIddata.data.updateqbTransaction);
          })
          .catch((qbSyncIderr) => {
            console.log(qbSyncIderr);
          });
      }
      // Update user with category & team;
      // Pass TEamId,CategoryId, Userid
      if (payload.userId) {
        apolloClient
          .mutate({
            mutation: CREATE_CATEGORY_TO_USER,
            variables: {
              teamId: updateUserExp.groupId,
              categoryId: updateUserExp.categoryId,
              userId: payload.userId,
            },
          })
          .then(() => {
            // this is Default
          })
          .catch((userIderr) => {
            console.log(userIderr);
          });
      }
    },

    getReceiptFromAWS({ commit }, payload) {
      const BUCKET_NAME = process.env.VUE_APP_RECEIPT_BUCKET_NAME;
      const IAM_USER_KEY = process.env.VUE_APP_AWS_IAM_USER_KEY;
      const IAM_USER_SECRET = process.env.VUE_APP_AWS_IAM_USER_SECRET;
      const s3bucket = new AWS.S3({
        accessKeyId: IAM_USER_KEY,
        secretAccessKey: IAM_USER_SECRET,
        Bucket: BUCKET_NAME,
      });
      const json = [];
      payload.forEach((item) => {
        const keyPart = item.link.split('.com/');
        const key = keyPart[1];
        const replaced = key.replace('%20', ' ');

        const params = {
          Bucket: BUCKET_NAME,
          Key: replaced,
          Expires: 240,
        };
        const url = s3bucket.getSignedUrl('getObject', params);
        json.push({ url, id: item.id, name: item.title });
      });
      commit('SET_RECEIPT_URL', json);
    },
    // As per New Wireframes Queries
    getUserCategory({ commit }, payload) {
      apolloClient
        .query({
          query: GET_USER_GROUP_CATEGORIES_GQL_NEW,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getUserCategorydata) => {
          const categoryBudgetList = [];
          getUserCategorydata.data.groups[0].categories.forEach((category) => {
            const categoryList = {};
            categoryList.id = category.id;
            categoryList.categoryName = category.categoryName;
            categoryList.users = category.users;
            categoryBudgetList.push(categoryList);
          });
          categoryBudgetList.groupId = getUserCategorydata.data.groups[0].id;
          commit('SET_CATEGORY_FOR_USER', categoryBudgetList);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getUserCategoryerr) => {
          console.log(getUserCategoryerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getCategoryTransactions({ commit }, payload) {
      apolloClient
        .query({
          query: GET_USER_ALL_TRANSACTIONS,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getCategoryTransactionsdata) => {
          const declinedTransaction = [];
          const approvedTransaction = [];
          const clearedTransaction = [];
          const flaggedTransaction = [];
          const pendingDataArray = [];
          getCategoryTransactionsdata.data.userExpenses.forEach((element) => {
            element.isSelected = false;
            if (element.status === false) {
              declinedTransaction.push(element);
            }
            if (element.isFlagged) {
              flaggedTransaction.push(element);
            }
            if (element.status === true) {
              if (element.recordStatus === 3 || element.recordStatus === 0) {
                approvedTransaction.push(element);
              } else if (element.recordStatus === 1 || element.recordStatus === 4) {
                clearedTransaction.push(element);
              }
            }
            // Merged code;
            if (element.expenseReceipts.length === 0) {
              if (
                element.recordStatus === 0
                || element.recordStatus === 1
                // || element.recordStatus === 3
              ) {
                if (element.status) {
                  pendingDataArray.push(element);
                }
              }
            }
          });

          const transactionStepOut = [9];
          const transaction = getCategoryTransactionsdata.data.userExpenses.filter((tran) => {
            if (!transactionStepOut.includes(tran.recordStatus)) {
              return tran;
            }
          });

          commit('SET_TRANSACTIONS', transaction);
          commit('SET_APPROVED_TRANSACTION', approvedTransaction);
          commit('SET_CLEARED_TRANSACTION', clearedTransaction);
          commit('SET_DECLINED_TRANSACTION', declinedTransaction);
          commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);
          commit('SET_PENDING_TRANSACTIONS', pendingDataArray);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getCategoryTransactionserr) => {
          console.log(getCategoryTransactionserr);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });
    },

    async getTeamCalculation({ commit }, payload) {
      // Do not display old loader if meta data variable has true value
      const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
      commit('shared/SET_LOADING_CHILD', loaderFlag, { root: true });
      await apolloClient
        .query({
          query: GET_TEAM_SPENT_TRANSACTIONS,
          variables: {
            groupId: payload.id,
            month: payload.month,
            year: payload.year,
            userId: payload.userId,
            companyId: payload.companyId,
            expenseDateGte: payload.expenseDateGte,
            expenseDateLte: payload.expenseDateLte,
          },
          fetchPolicy: 'network-only',
        })
        .then((getTeamCalculationdata) => {
          if (payload.userStatus === 'Employee') {
            const { userBudgetAmount, userSpentAmount } = getTeamCalculationdata.data.getTeamSpentTransactions[0];
            getTeamCalculationdata.data.getTeamSpentTransactions[0].allocated = userBudgetAmount;
            getTeamCalculationdata.data.getTeamSpentTransactions[0].expense = userSpentAmount;
          }

          const transactionStepOut = [9];
          const transaction = getTeamCalculationdata.data.getTeamSpentTransactions.filter((tran) => {
            if (!transactionStepOut.includes(tran.recordStatus)) {
              return tran;
            }
          });

          commit('SET_TEAMWISE_EXPENCE_CARD', transaction);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getTeamCalculationerr) => {
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
          console.log(getTeamCalculationerr);
        });
    },

    async getcategoryCalculation({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_CATEGORY_EXPENSE_CALCULATION_CARD,
          variables: {
            id: payload.id,
            month: payload.month,
            year: payload.year,
          },
          fetchPolicy: 'network-only',
        })
        .then((getcategoryCalculationdata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_CATEGORYWISE_EXPENCE_CARD', getcategoryCalculationdata.data.categoryBudgetCalculationCard);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getcategoryCalculationerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getcategoryCalculationerr);
        });
    },

    async getCategoryBudgetCalculation({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_CATEGORY_SPENT_TRANSACTION,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getCategoryBudgetCalculationdata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          if (payload.userStatus === 'Employee') {
            const { userSpentAmount, userBudgetAmount } = getCategoryBudgetCalculationdata.data.getCategorySpentTransactions[0];
            getCategoryBudgetCalculationdata.data.getCategorySpentTransactions[0].allocated = userBudgetAmount;
            getCategoryBudgetCalculationdata.data.getCategorySpentTransactions[0].expense = userSpentAmount;
          }
          commit('SET_CATEGORY_BUDGET_CALCULATION', getCategoryBudgetCalculationdata.data.getCategorySpentTransactions);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((getCategoryBudgetCalculationerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getCategoryBudgetCalculationerr);
        });
    },

    getCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_CATEGORY_NAME_GQL,
          variables: payload,
        })
        .then((getCategorydata) => {
          commit('SET_CATEGORY_NAME', getCategorydata.data.categories);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getCategoryerr) => {
          console.log(getCategoryerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getTeamSpentBudget({ commit }, payload) {
      apolloClient
        .query({
          query: GET_TEAM_SPENT_TRANSACTIONS,
          variables: {
            groupId: payload.groupId,
            month: payload.month,
            year: payload.year,
            userId: payload.userId,
            companyId: payload.companyId,
          },
          fetchPolicy: 'network-only',
        })
        .then((getTeamSpentBudgetdata) => {
          commit('SET_TEAM_SPENT_BUDGET', getTeamSpentBudgetdata.data.getTeamSpentTransactions[0]);
        })
        .catch((getTeamSpentBudgeterr) => {
          console.log(getTeamSpentBudgeterr);
        });
    },

    getTeamSpentTransaction({ commit }, payload) {
      apolloClient
        .query({
          query: GET_TEAM_SPENT_TRANSACTIONS,
          variables: {
            groupId: payload.groupId,
            companyId: payload.companyId,
            month: payload.month,
            year: payload.year,
            userId: payload.userId,
            expenseDateGte: payload.expenseDateGte,
            expenseDateLte: payload.expenseDateLte,
          },
          fetchPolicy: 'no-cache',
        })
        .then((getTeamSpentTransactiondata) => {
          const newArray = getTeamSpentTransactiondata.data.getTeamSpentTransactions.filter(value => value.groupName !== 'Uncategorized');
          const filterValue = getTeamSpentTransactiondata.data.getTeamSpentTransactions.filter(team => team.groupName === 'Uncategorized');
          if (filterValue.length) {
            filterValue[0].color = '#388E3C';
            filterValue[0].icon = 'globe';
            filterValue[0].slug = 'uncategorzed';
            filterValue[0].users = [];
            commit('SET_UNCATEGORY_SPENT_TRANSACTION', filterValue);
          } else {
            commit('SET_UNCATEGORY_SPENT_TRANSACTION', filterValue);
          }
          newArray.forEach((element, index) => {
            const role = payload.role[index];
            if (role === 'Employee') {
              newArray[index].allocated = element.userBudgetAmount;
              newArray[index].expense = element.userSpentAmount;
            }
          });

          commit('SET_TEAM_SPENT_TRANSACTIONS', newArray);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamSpentTransactionerr) => {
          console.log(getTeamSpentTransactionerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },

    getCategorySpentTransaction({ commit }, payload) {
      commit('SET_CATEGORY_SPENT_TRANSACTIONS', []);
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_CATEGORY_SPENT_TRANSACTION,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getCategorySpentTransactiondata) => {
          if (payload.userStatus === 'Employee') {
            getCategorySpentTransactiondata.data.getCategorySpentTransactions.forEach((item, index) => {
              getCategorySpentTransactiondata.data.getCategorySpentTransactions[index].allocated = item.userBudgetAmount;
              getCategorySpentTransactiondata.data.getCategorySpentTransactions[index].expense = item.userSpentAmount;
            });
            commit('SET_CATEGORY_SPENT_TRANSACTIONS', getCategorySpentTransactiondata.data.getCategorySpentTransactions);
          } else {
            commit('SET_CATEGORY_SPENT_TRANSACTIONS', getCategorySpentTransactiondata.data.getCategorySpentTransactions);
          }
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getCategorySpentTransactionerr) => {
          console.log(getCategorySpentTransactionerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },

    getUnCategorizedTransaction({ commit }, payload) {
      apolloClient
        .query({
          query: GET_UN_CATEGORIZED_TRANSACTIONS_1,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getUnCategorizedTransactiondata) => {
          // eslint-disable-next-line max-len
          // const userExp = data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
          const userExp = getUnCategorizedTransactiondata.data.userExpenses;
          const declinedTransaction = [];
          const approvedTransaction = [];
          const clearedTransaction = [];
          const pendingTransaction = [];
          const flaggedTransaction = [];
          userExp.forEach((element) => {
            element.isSelected = false;
            if (element.isFlagged) {
              flaggedTransaction.push(element);
            }
            if (element.status === false) {
              declinedTransaction.push(element);
            }
            if (element.status === true) {
              if (element.recordStatus === 3 || element.recordStatus === 0) {
                approvedTransaction.push(element);
              } else if (element.recordStatus === 1 || element.recordStatus === 4) {
                if (element.expenseReceipts.length === 0) {
                  pendingTransaction.push(element);
                }
                clearedTransaction.push(element);
              }
            }
          });
          commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', userExp);
          commit('SET_APPROVED_TRANSACTION', approvedTransaction);
          commit('SET_CLEARED_TRANSACTION', clearedTransaction);
          commit('SET_DECLINED_TRANSACTION', declinedTransaction);
          commit('SET_PENDING_TRANSACTIONS', pendingTransaction);
          commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getUnCategorizedTransactionerr) => {
          console.log(getUnCategorizedTransactionerr);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });
    },

    getDashboardTransactions({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_DASHBOARD_TRANSACTION,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getDashboardTransactionsdata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_DASHBOARD_TRANSACTION', getDashboardTransactionsdata.data.userExpenses.reverse());
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getDashboardTransactionserr) => {
          console.log(getDashboardTransactionserr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getUserUnCategorized({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USER_GROUP_CATEGORIES_GQL_NEW,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getUserUnCategorizeddata) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          const categoryBudgetList = [];
          const categoryBudgetList2 = [];
          getUserUnCategorizeddata.data.groups[0].categories.forEach((category) => {
            const categoryList = {};
            categoryList.id = category.id;
            categoryList.categoryName = category.categoryName;
            categoryBudgetList2.push(categoryList);
            categoryList.users = category.users;
            categoryBudgetList.push(categoryList);
          });
          categoryBudgetList.groupId = getUserUnCategorizeddata.data.groups[0].id;
          commit('SET_CATEGORY_FOR_USER_TRANSACTION', categoryBudgetList);
          commit('SET_CATEGORY_FOR_USER_TRANSACTION_2', categoryBudgetList2);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getUserUnCategorizederr) => {
          console.log(getUserUnCategorizederr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getUserRoleForTeam({
      commit,
    }, payload) {
      apolloClient
        .query({
          query: GET_TEAM_TO_USERS_GQL,
          variables: { userId: payload.userId, recordStatus: 1 },
          fetchPolicy: 'network-only',
        })
        .then((getUserRoleForTeamdata) => {
          let userRole = getUserRoleForTeamdata.data.teamToUsers.filter(role => role.role.roleName === 'Admin');
          if (userRole.length) {
            commit('SET_USER_ROLE_TEAM', userRole);
          } else {
            userRole = getUserRoleForTeamdata.data.teamToUsers.filter(role => role.team.id === payload.teamId);
            commit('SET_USER_ROLE_TEAM', userRole);
          }
        })
        .catch((getUserRoleForTeamerr) => {
          console.log(getUserRoleForTeamerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    getUserSpentBudget({
      commit,
    }, payload) {
      apolloClient
        .query({
          query: GET_USER_ALL_TRANSACTIONS,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getUserSpentBudgetdata) => {
          const transactions = getUserSpentBudgetdata.data.userExpenses;
          let userSpentAmount = 0;
          if (transactions.length) {
            // eslint-disable-next-line no-plusplus
            for (let index = 0; index < transactions.length; index++) {
              const element = transactions[index];
              userSpentAmount += element.amount;
            }
          }
          commit('SET_USER_SPENT_AMOUNT', userSpentAmount);
        })
        .catch((getUserSpentBudgeterror) => {
          console.log(getUserSpentBudgeterror);
        });
    },


    async getAllTransactionForMe({ commit, _state }, payload) {
      // get All transaction for ginven date range for loggeding user only
      apolloClient
        .query({
          query: GET_ALL_MY_TRANSACTIONS,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getAllTransactionForMeData) => {
          const declinedTransaction = [];
          const approvedTransaction = [];
          const clearedTransaction = [];
          let pendingTransaction = [];
          const flaggedTransaction = [];
          // eslint-disable-next-line max-len
          const userExp = getAllTransactionForMeData.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
          pendingTransaction = userExp.filter(transaction => transaction.recordStatus === 1);
          getAllTransactionForMeData.data.userExpenses.forEach((element) => {
            element.isSelected = false;
            if (element.status === false) {
              declinedTransaction.push(element);
            }
            if (element.isFlagged) {
              flaggedTransaction.push(element);
            }
            if (element.status === true) {
              if (element.recordStatus === 3 || element.recordStatus === 0) {
                approvedTransaction.push(element);
              } else if (element.recordStatus === 1 || element.recordStatus === 4) {
                clearedTransaction.push(element);
              }
            }
          });

          const transactionStepOut = [9];
          const transaction = getAllTransactionForMeData.data.userExpenses.filter((tran) => {
            if (!transactionStepOut.includes(tran.recordStatus)) {
              return tran;
            }
          });


          commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
          commit('SET_APPROVED_TRANSACTION', approvedTransaction);
          commit('SET_CLEARED_TRANSACTION', clearedTransaction);
          commit('SET_DECLINED_TRANSACTION', declinedTransaction);
          commit('SET_PENDING_TRANSACTIONS', pendingTransaction);
          commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);

          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getAllTransactionForMeerror) => {
          console.log('E=>', getAllTransactionForMeerror);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });

      // get Uncategoriseid transactions for users
      apolloClient
        .query({
          query: GET_UN_CATEGORIZED_MY_TRANSACTION,
          variables: payload,
          fetchPolicy: 'no-cache',
          // fetchPolicy: 'network-only',
        })
        .then((getAllTransactionForMeUncategorized) => {
          // Adding isSelected property to all transactions to handle checkbox v-model state
          getAllTransactionForMeUncategorized.data.userExpenses.forEach((transaction) => {
            transaction.isSelected = false;
          });
          commit('SET_ALL_UNCATEGORIZED_TRANSACTIONS', getAllTransactionForMeUncategorized.data.userExpenses);
        });
    },

    // code start here
    async getAllTransaction({ commit, state }, payload) {
      // Check if bulk transactions is enabled - for this call, we still want to fetch transactions
      // unlike other supporting API calls that we skip entirely
      console.log('getAllTransaction called with payload:', payload);
      
      if (isBulkTransactionsEnabled()) {
        console.log('Bulk transactions is enabled, but we still need to fetch company transactions');
        // We don't want to skip this call, just log it
      }

      let hideLoader = true;
      if (payload.hideLoader) {
        hideLoader = false;
      }
      const payload1 = {
        companyId: payload.companyId,
        expenseDateLte: payload.expenseDateLte,
        expenseDateGte: payload.expenseDateGte,
        categorizationDate: payload.categorizationDate,
      };
      let flag = 1;
      payload.permissionPayload.forEach((teamList) => {
        if (teamList.team.slug === 'all-teams') {
          teamList.permissions2.forEach((perm) => {
            if (perm.slug === 'view_team_transactions') {
              flag = 2;
            }
          });
        }
      });

      if (flag === 2) {
        if (hideLoader) {
          // Do not display old loader if meta data variable has true value
          const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
          commit('shared/SET_LOADING_CHILD', loaderFlag, {
            root: true,
          });
        }


        // As Manager;
        apolloClient
          .query({
            query: GET_UN_CATEGORIZED_FOR_TAB,
            variables: payload1,
            fetchPolicy: 'no-cache',
            // fetchPolicy: 'network-only',
          })
          .then((getAllTransactiondata) => {
            // Adding isSelected property to all transactions to handle checkbox v-model state
            getAllTransactiondata.data.uncategorizeUserExpensesOnly.forEach((transaction) => {
              transaction.isSelected = false;
            });
            const transactionStepOut = [9];
            const transaction = getAllTransactiondata.data.uncategorizeUserExpensesOnly.filter((tran) => {
              if (!transactionStepOut.includes(tran.recordStatus)) {
                return tran;
              }
            });
            commit('SET_ALL_UNCATEGORIZED_TRANSACTIONS', transaction);
          });

        apolloClient
          .query({
            query: GET_UN_CATEGORIZED_TRANSACTIONS,
            variables: payload1,
            fetchPolicy: 'no-cache',
            // fetchPolicy: 'network-only',
          })
          .then((unCatedata) => {
            const declinedTransaction = [];
            const approvedTransaction = [];
            const clearedTransaction = [];
            let pendingTransaction = [];
            const flaggedTransaction = [];
            // eslint-disable-next-line max-len
            const userExp = unCatedata.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
            pendingTransaction = userExp.filter(transaction => transaction.recordStatus === 1);
            unCatedata.data.userExpenses.forEach((element) => {
              element.isSelected = false;
              if (element.status === false) {
                declinedTransaction.push(element);
              }
              if (element.isFlagged) {
                flaggedTransaction.push(element);
              }
              if (element.status === true) {
                if (element.recordStatus === 3 || element.recordStatus === 0) {
                  approvedTransaction.push(element);
                } else if (element.recordStatus === 1 || element.recordStatus === 4) {
                  clearedTransaction.push(element);
                }
              }
            });

            const transactionStepOut = [9];
            const transaction = unCatedata.data.userExpenses.filter((tran) => {
              if (!transactionStepOut.includes(tran.recordStatus)) {
                return tran;
              }
            });

            commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
            commit('SET_APPROVED_TRANSACTION', approvedTransaction);
            commit('SET_CLEARED_TRANSACTION', clearedTransaction);
            commit('SET_DECLINED_TRANSACTION', declinedTransaction);
            commit('SET_PENDING_TRANSACTIONS', pendingTransaction);
            commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);

            commit('shared/SET_LOADING_CHILD', false, {
              root: true,
            });
          })
          .catch((unCatedataerror) => {
            console.log('E=>', unCatedataerror);
            commit('shared/SET_LOADING_CHILD', false, {
              root: true,
            });
          });
      }
      if (flag === 1) {
        if (hideLoader) {
          commit('shared/SET_LOADING_CHILD', true, {
            root: true,
          });
        }
        let isManager = false;
        let isEmployee = false;
        const tempTeamIds = [];
        let chkPerm = false;


        payload.permissionPayload.forEach((teamList) => {
          chkPerm = false;
          teamList.permissions2.forEach((perm) => {
            if (perm.slug === 'view_team_transactions') {
              chkPerm = true;
            }
          });
          if (chkPerm === true) {
            tempTeamIds.push(teamList.team.id);
            isManager = true;
          } else {
            tempTeamIds.push(teamList.team.id);
          }
        });
        // }

        if (!isManager && !isEmployee) {
          isEmployee = true;
        }

        const declinedTransaction = [];
        const approvedTransaction = [];
        const clearedTransaction = [];
        let pendingTransaction = [];
        const flaggedTransaction = [];
        if (isManager) {
          if (hideLoader) {
            commit('shared/SET_LOADING_CHILD', true, {
              root: true,
            });
          }
          const payload2 = { ...payload1, groupId: tempTeamIds };
          apolloClient
            .query({
              query: GET_ALL_TRANSACTIONS,
              variables: payload2,
              fetchPolicy: 'no-cache',
            })
            .then((payload2data) => {
              // eslint-disable-next-line max-len
              const userExp = payload2data.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
              pendingTransaction = userExp.filter(transaction => transaction.recordStatus === 1);
              // eslint-disable-next-line array-callback-return
              payload2data.data.userExpenses.map((elementUE) => {
                elementUE.isSelected = false;
                if (elementUE.status === false) {
                  declinedTransaction.push(elementUE);
                }
                if (elementUE.isFlagged) {
                  flaggedTransaction.push(elementUE);
                }
                if (elementUE.status === true) {
                  if (elementUE.recordStatus === 3 || elementUE.recordStatus === 0) {
                    approvedTransaction.push(elementUE);
                  } else if (elementUE.recordStatus === 1 || elementUE.recordStatus === 4) {
                    clearedTransaction.push(elementUE);
                  }
                }
              });


              if (isEmployee) {
                const transactionStepOut = [9];
                const transaction = [...state.unCategorizedTransactions, ...payload2data.data.userExpenses].filter((tran) => {
                  if (!transactionStepOut.includes(tran.recordStatus)) {
                    return tran;
                  }
                });

                commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
                commit('SET_APPROVED_TRANSACTION', [...state.approvedTransaction, ...approvedTransaction]);
                commit('SET_CLEARED_TRANSACTION', [...state.clearedTransaction, ...clearedTransaction]);
                commit('SET_DECLINED_TRANSACTION', [...state.declinedTransaction, ...declinedTransaction]);
                commit('SET_PENDING_TRANSACTIONS', [...state.getPendingTransaction, ...pendingTransaction]);
                commit('SET_FLAGGED_TRANSACTIONS', [...state.flaggedTransaction, ...flaggedTransaction]);
              } else {
                const transactionStepOut = [9];
                const transaction = payload2data.data.userExpenses.filter((tran) => {
                  if (!transactionStepOut.includes(tran.recordStatus)) {
                    return tran;
                  }
                });
                commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
                commit('SET_APPROVED_TRANSACTION', approvedTransaction);
                commit('SET_CLEARED_TRANSACTION', clearedTransaction);
                commit('SET_DECLINED_TRANSACTION', declinedTransaction);
                commit('SET_PENDING_TRANSACTIONS', pendingTransaction);
                commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);
              }


              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            })
            .catch((error) => {
              console.log(error);
              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            });
        }
        if (isEmployee) {
          if (hideLoader) {
            // Do not display old loader if meta data variable has true value
            const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
            commit('shared/SET_LOADING_CHILD', loaderFlag, {
              root: true,
            });
          }
          const payload3 = payload1;
          apolloClient
            .query({
              query: GET_UN_CATEGORIZED_TRANSACTIONS,
              variables: payload3,
              fetchPolicy: 'no-cache',
            })
            .then((payload3data) => {
              console.log('Step 3', payload3data);
              // eslint-disable-next-line max-len
              const userExp = payload3data.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
              pendingTransaction = userExp.filter(transaction => transaction.recordStatus !== 2);

              // eslint-disable-next-line array-callback-return
              payload3data.data.userExpenses.map((elementUC) => {
                elementUC.isSelected = false;
                if (elementUC.status === false) {
                  declinedTransaction.push(elementUC);
                }
                if (elementUC.isFlagged) {
                  flaggedTransaction.push(elementUC);
                }
                if (elementUC.status === true) {
                  if (elementUC.recordStatus === 3 || elementUC.recordStatus === 0) {
                    approvedTransaction.push(elementUC);
                  } else if (elementUC.recordStatus === 1 || elementUC.recordStatus === 4) {
                    clearedTransaction.push(elementUC);
                  }
                }
              });

              const allPendingTransaction = state.getPendingTransaction;
              if (isManager) {
                const transactionStepOut = [9];
                const transaction = [...state.unCategorizedTransactions, ...payload3data.data.userExpenses].filter((tran) => {
                  if (!transactionStepOut.includes(tran.recordStatus)) {
                    return tran;
                  }
                });


                commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
                commit('SET_APPROVED_TRANSACTION', [...state.approvedTransaction, ...approvedTransaction]);
                commit('SET_CLEARED_TRANSACTION', [...state.clearedTransaction, ...clearedTransaction]);
                commit('SET_DECLINED_TRANSACTION', [...state.declinedTransaction, ...declinedTransaction]);
                commit('SET_PENDING_TRANSACTIONS', [...state.getPendingTransaction, ...pendingTransaction]);
                commit('SET_FLAGGED_TRANSACTIONS', [...state.flaggedTransaction, ...flaggedTransaction]);
              } else {
                const transactionStepOut = [9];
                const transaction = payload3data.data.userExpenses.filter((tran) => {
                  if (!transactionStepOut.includes(tran.recordStatus)) {
                    return tran;
                  }
                });
                commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
                commit('SET_APPROVED_TRANSACTION', approvedTransaction);
                commit('SET_CLEARED_TRANSACTION', clearedTransaction);
                commit('SET_DECLINED_TRANSACTION', declinedTransaction);
                commit('SET_PENDING_TRANSACTIONS', allPendingTransaction);
                commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);
              }

              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            })
            .catch((payload3error) => {
              console.log(payload3error);
              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            });
        }
      }
    },

    async getAllTransactionForCard({ commit, state }, payload) {
      let hideLoader = true;
      if (payload.hideLoader) {
        hideLoader = false;
      }
      const cardId = [];
      if (payload.cards) {
        if (payload.cards.length) {
          payload.cards.forEach((item) => {
            cardId.push(item.id);
          });
        }
      }


      const payload1 = {
        cards: cardId,
        companyId: payload.companyId,
        expenseDateLte: payload.expenseDateLte,
        expenseDateGte: payload.expenseDateGte,
        categorizationDate: payload.categorizationDate,
      };
      let flag = 1;
      payload.permissionPayload.forEach((teamListOne) => {
        if (teamListOne.team.slug === 'all-teams') {
          teamListOne.permissions2.forEach((permOne) => {
            if (permOne.slug === 'view_team_transactions') {
              flag = 2;
            }
          });
        }
      });


      if (flag === 2) {
        if (hideLoader) {
          // Do not display old loader if meta data variable has true value
          const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
          commit('shared/SET_LOADING_CHILD', loaderFlag, {
            root: true,
          });
        }

        // As Manager;
        apolloClient
          .query({
            query: GET_UN_CATEGORIZED_FOR_TAB,
            variables: payload1,
            fetchPolicy: 'no-cache',
            // fetchPolicy: 'network-only',
          })
          .then((getAllTransactionForCarddata) => {
            // Adding isSelected property to all transactions to handle checkbox v-model state
            getAllTransactionForCarddata.data.uncategorizeUserExpensesOnly.forEach((transaction) => {
              transaction.isSelected = false;
            });
            const transactionStepOut = [9];
            const transaction = getAllTransactionForCarddata.data.uncategorizeUserExpensesOnly.filter((tran) => {
              if (!transactionStepOut.includes(tran.recordStatus)) {
                return tran;
              }
            });
            commit('SET_ALL_UNCATEGORIZED_TRANSACTIONS', transaction);
          });

        apolloClient
          .query({
            query: GET_UN_CATEGORIZED_TRANSACTIONS,
            variables: payload1,
            fetchPolicy: 'no-cache',
            // fetchPolicy: 'network-only',
          })
          .then((uncategorizeddata) => {
            const declinedTransaction = [];
            const approvedTransaction = [];
            const clearedTransaction = [];
            let pendingTransaction = [];
            const flaggedTransaction = [];
            // eslint-disable-next-line max-len
            const userExp = uncategorizeddata.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
            pendingTransaction = userExp.filter(transaction => transaction.recordStatus === 1);
            uncategorizeddata.data.userExpenses.forEach((elementUEOne) => {
              elementUEOne.isSelected = false;
              if (elementUEOne.status === false) {
                declinedTransaction.push(elementUEOne);
              }
              if (elementUEOne.isFlagged) {
                flaggedTransaction.push(elementUEOne);
              }
              if (elementUEOne.status === true) {
                if (elementUEOne.recordStatus === 3 || elementUEOne.recordStatus === 0) {
                  approvedTransaction.push(elementUEOne);
                } else if (elementUEOne.recordStatus === 1 || elementUEOne.recordStatus === 4) {
                  clearedTransaction.push(elementUEOne);
                }
              }
            });
            const transactionStepOut = [9];
            const transaction = uncategorizeddata.data.userExpenses.filter((tran) => {
              if (!transactionStepOut.includes(tran.recordStatus)) {
                return tran;
              }
            });

            commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
            commit('SET_APPROVED_TRANSACTION', approvedTransaction);
            commit('SET_CLEARED_TRANSACTION', clearedTransaction);
            commit('SET_DECLINED_TRANSACTION', declinedTransaction);
            commit('SET_PENDING_TRANSACTIONS', pendingTransaction);
            commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);

            commit('shared/SET_LOADING_CHILD', false, {
              root: true,
            });
          })
          .catch((getAllTransactionForCarderror) => {
            console.log('E=>', getAllTransactionForCarderror);
            commit('shared/SET_LOADING_CHILD', false, {
              root: true,
            });
          });
      }
      if (flag === 1) {
        console.log('Flag-1');
        if (hideLoader) {
          commit('shared/SET_LOADING_CHILD', true, {
            root: true,
          });
        }
        let isManager = false;
        let isEmployee = false;
        const tempTeamIds = [];
        let chkPerm = false;
        payload.permissionPayload.forEach((teamList) => {
          chkPerm = false;
          teamList.permissions2.forEach((perm2) => {
            if (perm2.slug === 'view_team_transactions') {
              chkPerm = true;
            }
          });
          if (chkPerm === true) {
            tempTeamIds.push(teamList.team.id);
            isManager = true;
          }
        });
        if (!isManager && !isEmployee) {
          isEmployee = true;
        }
        const declinedTransaction = [];
        const approvedTransaction = [];
        const clearedTransaction = [];
        let pendingTransaction = [];
        const flaggedTransaction = [];
        if (isManager) {
          if (hideLoader) {
            // Do not display old loader if meta data variable has true value
            const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
            commit('shared/SET_LOADING_CHILD', loaderFlag, {
              root: true,
            });
          }
          // As Manager;
          apolloClient
            .query({
              query: GET_UN_CATEGORIZED_FOR_TAB,
              variables: payload1,
              fetchPolicy: 'no-cache',
              // fetchPolicy: 'network-only',
            })
            .then((payload1data) => {
              // Adding isSelected property to all transactions to handle checkbox v-model state
              payload1data.data.uncategorizeUserExpensesOnly.forEach((transaction) => {
                transaction.isSelected = false;
              });

              const transactionStepOut = [9];
              const transaction = payload1data.data.uncategorizeUserExpensesOnly.filter((tran) => {
                if (!transactionStepOut.includes(tran.recordStatus)) {
                  return tran;
                }
              });

              commit('SET_ALL_UNCATEGORIZED_TRANSACTIONS', transaction);
            });
          const payload2 = { ...payload1, groupId: tempTeamIds };
          // As Manager;


          apolloClient
            .query({
              query: GET_ALL_TRANSACTIONS,
              variables: payload2,
              fetchPolicy: 'no-cache',
            })
            .then((allTransactiondata) => {
              // eslint-disable-next-line max-len
              const userExp = allTransactiondata.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
              pendingTransaction = userExp.filter(transaction => transaction.recordStatus === 1);
              // eslint-disable-next-line array-callback-return
              allTransactiondata.data.userExpenses.map((elementAll) => {
                if (elementAll.status === false) {
                  declinedTransaction.push(elementAll);
                }
                if (elementAll.isFlagged) {
                  flaggedTransaction.push(elementAll);
                }
                if (elementAll.status === true) {
                  if (elementAll.recordStatus === 3 || elementAll.recordStatus === 0) {
                    approvedTransaction.push(elementAll);
                  } else if (elementAll.recordStatus === 1 || elementAll.recordStatus === 4) {
                    clearedTransaction.push(elementAll);
                  }
                }
              });

              const transactionStepOut = [9];
              const transaction = allTransactiondata.data.userExpenses.filter((tran) => {
                if (!transactionStepOut.includes(tran.recordStatus)) {
                  return tran;
                }
              });

              commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
              commit('SET_APPROVED_TRANSACTION', approvedTransaction);
              commit('SET_CLEARED_TRANSACTION', clearedTransaction);
              commit('SET_DECLINED_TRANSACTION', declinedTransaction);
              commit('SET_PENDING_TRANSACTIONS', pendingTransaction);
              commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);
              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            })
            .catch((errorOne) => {
              console.log(errorOne);
              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            });
        }
        if (isEmployee) {
          if (hideLoader) {
            // Do not display old loader if meta data variable has true value
            const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
            commit('shared/SET_LOADING_CHILD', loaderFlag, {
              root: true,
            });
          }

          const payload3 = { ...payload1, userId: payload.userId };


          // As Manager;
          apolloClient
            .query({
              query: GET_UN_CATEGORIZED_FOR_TAB,
              variables: payload3,
              fetchPolicy: 'no-cache',
              // fetchPolicy: 'network-only',
            })
            .then((payload3data) => {
              payload3data.data.uncategorizeUserExpensesOnly.forEach((transaction) => {
                transaction.isSelected = false;
              });

              const transactionStepOut = [9];
              const transaction = payload3data.data.uncategorizeUserExpensesOnly.filter((tran) => {
                if (!transactionStepOut.includes(tran.recordStatus)) {
                  return tran;
                }
              });

              commit('SET_ALL_UNCATEGORIZED_TRANSACTIONS', transaction);
            });

          apolloClient
            .query({
              query: GET_UN_CATEGORIZED_TRANSACTIONS,
              variables: payload3,
              fetchPolicy: 'no-cache',
            })
            .then((payload3Uncategorizeddata) => {
              // console.log(3, data.userExpenses);
              // eslint-disable-next-line max-len
              const userExp = payload3Uncategorizeddata.data.userExpenses.filter(transaction => transaction.expenseReceipts.length === 0);
              pendingTransaction = userExp.filter(transaction => transaction.recordStatus !== 2);

              // eslint-disable-next-line array-callback-return
              payload3Uncategorizeddata.data.userExpenses.map((elementUserExp) => {
                if (elementUserExp.status === false) {
                  declinedTransaction.push(elementUserExp);
                }
                if (elementUserExp.isFlagged) {
                  flaggedTransaction.push(elementUserExp);
                }
                if (elementUserExp.status === true) {
                  if (elementUserExp.recordStatus === 3 || elementUserExp.recordStatus === 0) {
                    approvedTransaction.push(elementUserExp);
                  } else if (elementUserExp.recordStatus === 1 || elementUserExp.recordStatus === 4) {
                    clearedTransaction.push(elementUserExp);
                  }
                }
              });

              const allPendingTransaction = state.getPendingTransaction;

              const transactionStepOut = [9];
              const transaction = payload3Uncategorizeddata.data.userExpenses.filter((tran) => {
                if (!transactionStepOut.includes(tran.recordStatus)) {
                  return tran;
                }
              });

              commit('SET_UNCATEGORY_SPENT_TRANSACTIONS', transaction);
              commit('SET_APPROVED_TRANSACTION', approvedTransaction);
              commit('SET_CLEARED_TRANSACTION', clearedTransaction);
              commit('SET_DECLINED_TRANSACTION', declinedTransaction);
              commit('SET_PENDING_TRANSACTIONS', allPendingTransaction);
              commit('SET_FLAGGED_TRANSACTIONS', flaggedTransaction);
              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            })
            .catch((errorAll) => {
              console.log(errorAll);
              commit('shared/SET_LOADING_CHILD', false, {
                root: true,
              });
            });
        }
      }
    },

    filterTransactionsByMerchant({ commit }, payload) {
      commit('SET_FILTER_ALL_TRANSACTIONS', payload);
    },
    // Download CSV from payment screen
    getTotalSum({ commit }, payload) {
      let total = 0;
      payload.forEach((item) => {
        total += item.amount;
      });
      commit('SET_SUM_OF_FACTOR_WISE', total);
    },

    getTransactionByCompany({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_TRANSACTIONS_BY_COMPANY,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getTransactionByCompanydata) => {
          const transactionStepOut = [9];
          const transaction = getTransactionByCompanydata.data.userExpensesCSV.filter((tran) => {
            if (!transactionStepOut.includes(tran.recordStatus)) {
              return tran;
            }
          });
          commit('GET_COMPANY_ALL_TRANSACTION', transaction);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTransactionByCompanyerr) => {
          console.log(getTransactionByCompanyerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    setDateRange({ commit }, payload) {
      commit('SET_DATE_RANGE', payload);
    },

    async mapMerchantforPhysicalCard({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: MAP_MERCHANT_TO_CATEGORY_GQL,
          variables: {
            Merchant: payload.merchantid,
            company: payload.compId,
            team: payload.groupId,
            category: payload.categoryId,
            cards: payload.cardId,
            recordStatus: payload.recordStatus,
            TransacisonsTag: payload.TransacisonsTagId,
          },
        })
        .then(async (mapMerchantforPhysicalCarddata) => {
          // ---
          if (payload.recordStatus) {
            await apolloClient
              .mutate({
                mutation: GET_MAP_ALL_MERCHANT_TO_TEAM_GQL,
                variables: {
                  categoryId: payload.categoryId,
                  groupId: payload.groupId,
                  cardId: payload.cardId,
                  compId: payload.compId,
                  parentMerchantId: payload.parentMerchantId,
                  merchantid: payload.merchantid,
                  currentTransactisonId: payload.currentTransactisonId,
                  TransacisonsTag: payload.TransacisonsTagId,
                },
              })
              .then((mapMerchantforPhysicalCard1data) => {
                commit('SET_MERCHANT_TO_CATEGORY_RANGE', mapMerchantforPhysicalCard1data.data);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              })
              .catch((mapMerchantforPhysicalCard1dataerr) => {
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
                console.log(mapMerchantforPhysicalCard1dataerr);
              });

            commit('shared/SET_LOADING', false, {
              root: true,
            });
          } else {
            commit('SET_MERCHANT_TO_CATEGORY_RANGE', mapMerchantforPhysicalCarddata.data);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          }
          // ---
        })
        .catch((mapMerchantforPhysicalCarderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(mapMerchantforPhysicalCarderr);
        });
    },

    async getMapMerchant({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_MAP_MERCHANT_TO_CATEGORY_GQL,
          variables: {
            Merchant: payload.merchantid,
            company: payload.compId,
            team: payload.groupId,
            category: payload.categoryId,
            cards: payload.cardId,
            TransacisonsTag: payload.TransacisonsTag,
          },
          fetchPolicy: 'network-only',
        })
        .then((getMapMerchantdata) => {
          commit('SET_MERCHANT_TO_CATEGORY_GROUP', getMapMerchantdata.data.getMapMerchantToCategory);
          commit('SET_MERCHANT_TO_CATEGORY_GROUP_TIME', new Date());
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getMapMerchanterr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getMapMerchanterr);
        });
    },

    async getTeams({ commit }, payload) {
      // Do not display old loader if meta data variable has true value
      const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
      commit('shared/SET_LOADING', loaderFlag, { root: true });

      await apolloClient
        .mutate({
          mutation: GET_TEAMS_COMPANY,
          variables: {
            Company: payload.id,
          },
        })
        .then((getTeamsdata) => {
          if (payload.variable === 'companyForAutoCategorization') {
            commit('SET_AUTO_CATEGORISE', getTeamsdata.data.groups);
          } else if (payload.variable === 'bulkCategorization') {
            commit('SET_TEAMS_FOR_BULK_CATEGORIZATION', getTeamsdata.data.groups);
          } else {
            commit('SET_TEAMS', getTeamsdata.data.groups);
          }

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getTeamserr);
        });
    },

    async getTeamsAllCompany({ commit }, payload) {
      // Do not display old loader if meta data variable has true value
      const loaderFlag = !(router.currentRoute.meta.hideOldLoader);
      commit('shared/SET_LOADING', loaderFlag, { root: true });
      await apolloClient
        .query({
          query: GET_TEAMS_COMPANY_LIST,
          variables: {
            Company: payload.ids,
          },
        })
        .then((getTeamsAllCompanydata) => {
          commit('SET_TEAMS_ALL_COMPANY', getTeamsAllCompanydata.data.groups);

          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamsAllCompanyerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getTeamsAllCompanyerr);
        });
    },

    async mapAllMapMerchantToTeam({ commit }) {
      commit('shared/SET_LOADING', true, { root: true });
    },

    async moveBudgetstoChild({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const files = payload.receipts;

      const BUCKET_NAME = process.env.VUE_APP_RECEIPT_BUCKET_NAME;
      const IAM_USER_KEY = process.env.VUE_APP_AWS_IAM_USER_KEY;
      const IAM_USER_SECRET = process.env.VUE_APP_AWS_IAM_USER_SECRET;

      const s3bucket = new AWS.S3({
        accessKeyId: IAM_USER_KEY,
        secretAccessKey: IAM_USER_SECRET,
        Bucket: BUCKET_NAME,
      });

      const usrObj = payload.userId;
      const updateUserExp = {
        description: payload.notes,
        id: payload.id,
        categoryId: payload.categoryId,
        groupId: payload.groupId,
        receipts: [],
        companyId: payload.companyId,
      };

      for (let i = 0; i < files.length; i += 1) {
        if (files[i].fileSelected) {
          const promise = new Promise((async (resolve) => {
            const itemFile = files[i];
            const fileName = itemFile.fileSelected.name;
            const type = fileName.split('.').pop();
            const timeStamp = Date.now();
            let contentType = '';
            if (type === 'pdf') {
              contentType = 'application/pdf';
            } else {
              contentType = `image/${type}`;
            }
            const newFileName = `${timeStamp}.${type}`;
            const objkey = `${usrObj}/${newFileName}`;
            const contentDeposition = `inline;filename="${objkey}"`;

            s3bucket.createBucket(async () => {
              const params = {
                Bucket: BUCKET_NAME,
                Key: objkey,
                Body: itemFile.fileSelected.raw,
                ContentDisposition: contentDeposition,
                ContentType: contentType,
              };

              await s3bucket.upload(params, async (err, dataImage) => {
                if (err) {
                  console.log(err);
                }
                const receipt = {
                  link: dataImage.Location,
                  recordStatus: 1,
                  title: fileName,
                };
                updateUserExp.receipts.push(receipt);
                resolve(receipt);
              });
            });
          }));

          // eslint-disable-next-line no-await-in-loop
          await Promise.all([promise]).then(() => {
            // Default
          });
        } // if
      } // For Loop Over
      // Clog
      // Send Data;
      await apolloClient
        .mutate({
          mutation: SET_COMPANY_TEAM_CATEGORY,
          variables: {
            ...updateUserExp,
          },
        })
        .then((dataCmpCategory) => {
          commit('MOVE_CATEGORY_TRANSACTION', dataCmpCategory.data.moveCompanyTransactions);
          commit('SET_MERCHANT_TO_CATEGORY_GROUP_TIME', new Date());
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((dataCmpCategoryerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(dataCmpCategoryerr);
        });
    },

    async removeBudgetstoChild({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: REMOVE_TRANSACTION,
          variables: {
            id: payload.id,
            categoryId: payload.categoryId,
          },
        })
        .then((removeBudgetstoChilddata) => {
          commit('REMOVE_CATEGORY_TRANSACTION', removeBudgetstoChilddata.data.removeCompanyTransactions);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((removeBudgetstoChilderr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(removeBudgetstoChilderr);
        });
    },

    async gotoCard({ commit }, payload) {
      commit('SET_TRANSACTIONS_DATA', { date: new Date(), data: payload });
    },

    async getSingleUserExpense({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_SINGLE_TRANSACTION,
          variables: {
            ...payload,
          },
          fetchPolicy: 'no-cache',
        }).then((getSingleUserExpensedata) => {
          commit('SET_SINGLE_TRANSACTION', getSingleUserExpensedata.data.userExpenses[0]);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        }).catch((getSingleUserExpenseerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getSingleUserExpenseerr);
        });
    },

    async getReceiptLinks({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_RECEIPT_LINKS,
          variables: {
            ...payload,
          },
          fetchPolicy: 'no-cache',
        }).then((getReceiptLinksdata) => {
          commit('SET_SINGLE_TRANSACTION', getReceiptLinksdata.data.userExpensesForReceiptLink[0]);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        }).catch((getReceiptLinkserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getReceiptLinkserr);
        });
    },

    async downalodXLCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_XLS_TRANSACTION,
          variables: {
            ...payload,
          },
          fetchPolicy: 'no-cache',
        }).then(({ data }) => {
          console.log('Download-XLS', data);
          commit('SET_DOWNLOAD_XLS_FILE', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        }).catch((downalodXLCategoryerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(downalodXLCategoryerr);
        });
    },

    async downloadXLTag({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_XLS_TRANSACTION_TAG,
          variables: {
            ...payload,
          },
          fetchPolicy: 'no-cache',
        }).then(({ data }) => {
          commit('SET_DOWNLOAD_XLS_FILE_TAG', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        }).catch((downloadXLTagerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(downloadXLTagerr);
        });
    },

    async downalodXLTeam({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_XLS_TRANSACTION_TEAM,
          variables: {
            ...payload,
          },
          fetchPolicy: 'no-cache',
        }).then(({ data }) => {
          commit('SET_DOWNLOAD_XLS_FILE_TEAM', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        }).catch((downalodXLTeamerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(downalodXLTeamerr);
        });
    },

    async deleteExtTransaction({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: DELETE_EXT_TRANSACTIONS,
          variables: {
            id: payload.id,
          },
        })
        .then((deleteExtTransactiondata) => {
          commit('REMOVE_DELETE_TRANS', deleteExtTransactiondata.data.deleteExtTransactions);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((deleteExtTransactionerr) => {
          console.log(deleteExtTransactionerr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async setInlineTransactions({ commit }, payload) {
      // Set Splitted transactsions
      commit('SET_INLINE_TRANSACTIONS', payload);
    },

    async removeMyTransaction({ commit }, payload) {
      commit('REMOVE_INLINE_TRANSACTIONS', payload);
    },


    async fnSetTableColumn({ commit }, payload) {
      commit('SET_TABLE_COLUMN', payload);
    },

    async updateTransactionApprovalStatus({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: UPDATE_USER_EXPENSE_GQL,
          variables: {
            id: payload.id,
            categoryId: payload.categoryId,
            groupId: payload.groupId,
            transactionApprovalStatus: payload.transactionApprovalStatus,
          },
        })
        .then((updateTransactionApprovalStatusdata) => {
          commit('SET_APPROVED_TRANSACTION_STATUS', updateTransactionApprovalStatusdata.data.updateUserExpense);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((updateTransactionApprovalStatuserr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(updateTransactionApprovalStatuserr);
        });
    },

    async createCategorybyXLSTeam({ commit }, payload) {
      const payload1 = [];
      payload.listTeam.forEach((item) => {
        if (item.length) {
          if (item[0] !== '' && item[0] !== null) {
            const teamName = item[0];
            let amount = 0;
            if (!isNaN(item[1])) {
              amount = Number(item[1]);
            }
            payload1.push(
              {
                teamName,
                amount,
              },
            );
          }
        }
      });

      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CREATE_TEAMS_BY_XLS,
          variables: {
            uploadXLSFileInputArrayInputData: payload1,
            CompanyId: payload.CompanyId,
          },
        })
        .then(() => {
          commit('SET_XLS_FILE', { date: new Date(), type: 'Teams' });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createCategorybyXLSTeamerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createCategorybyXLSTeamerr);
        });
    },

    async setActiveTabName({ commit }, payload) {
      commit('SET_TAB_NAME', payload);
    },

    async createCategorybyXLSTag({ commit }, payload) {
      const payload1 = [];
      payload.listCategory.forEach((item) => {
        if (item.length) {
          if (item[0] !== '' && item[0] !== null && item[0] !== undefined) {
            const tagName = item[0];
            payload1.push(
              {
                tagName,
              },
            );
          }
        }
      });

      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CREATE_TAG_BY_XLS,
          variables: {
            uploadXLSFileInputArrayInputData: payload1,
            CompanyId: payload.CompanyId,
            teamId: payload.teamId,
          },
        })
        .then((data) => {
          commit('SET_XLS_FILE', { date: new Date(), mydata: data, type: 'Tags' });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createCategorybyXLSTagerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createCategorybyXLSTagerr);
        });
    },

    async createCategorybyXLS({ commit }, payload) {
      const payload1 = [];
      payload.listCategory.forEach((item) => {
        if (item.length) {
          if (item[0] !== '' && item[0] !== null && item[0] !== undefined) {
            const categoryName = item[0];
            let amount = 0;
            if (!isNaN(item[1])) {
              amount = Number(item[1]);
            }
            payload1.push(
              {
                categoryName,
                amount,
              },
            );
          }
        }
      });

      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: CREATE_CATEGORY_BY_XLS,
          variables: {
            uploadXLSFileInputArrayInputData: payload1,
            CompanyId: payload.CompanyId,
            teamId: payload.teamId,
          },
        })
        .then((data) => {
          commit('SET_XLS_FILE', { date: new Date(), mydata: data, type: 'Categories' });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createCategorybyXLSerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createCategorybyXLSerr);
        });
    },

    async storeColumnSelectionInTable({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: STORE_TRANSCREEN_COL_SEL_IN_DB_GQL,
          variables: {
            ...payload,
          },
        })
        .then(() => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((storeColumnSelectionInTableerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(storeColumnSelectionInTableerr);
        });
    },

    async cacheSelectedTransactions({ commit }, payload) {
      commit('SET_SELECTED_TRANSACTIONS', payload);
    },
    // Bulk Categorize transactions
    async performBulkCategorization({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_PERFORM_BULK_CATEGORIZATION_GQL,
          variables: {
            ...payload,
          },
        })
        .then((performBulkCategorizationdata) => {
          commit('SET_PERFORM_BULK_CATEGORIZATION', performBulkCategorizationdata.data.performBulkCategorization);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((performBulkCategorizationerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(performBulkCategorizationerr);
        });
    },
    // getMoveTransactionHistory
    async getMoveTransactionHistory({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .query({
          query: GET_MOVE_TRANSACTION_HISTORY,
          variables: payload,
          fetchPolicy: 'no-cache',
        }).then((getMoveTransactionHistorydata) => {
          commit('SET_MOVE_TRANSACTION_HISTORY', getMoveTransactionHistorydata.data.transactionMoveHistories);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        }).catch((getMoveTransactionHistoryerr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getMoveTransactionHistoryerr);
        });
    },

    async setGroupName({ commit }, payload) {
      commit('SET_TEAMS', payload);
    },


  },
  getters: {
    receiptData: state => state.receiptData,
    receiptUrl: state => state.receiptUrl,
    getUserCategories: state => state.getUserCategories,
    getWithoutUserCategories: state => state.getWithoutUserCategories,
    getCatTransaction: state => state.getCatTransaction,
    declinedTransaction: state => state.declinedTransaction,
    approvedTransaction: state => state.approvedTransaction,
    clearedTransaction: state => state.clearedTransaction,
    getPendingTransaction: state => state.getPendingTransaction,
    flaggedTransaction: state => state.flaggedTransaction,
    getCategoryName: state => state.getCategoryName,
    transactionMyTeam: state => state.transactionMyTeam,
    getTeamBudget: state => state.getTeamBudget,
    getCategoryBudget: state => state.getCategoryBudget,
    categoryBudgetCalculation: state => state.categoryBudgetCalculation,
    teamSpentTransactions: state => state.teamSpentTransactions,
    teamSpendBudgetAmount: state => state.teamSpendBudgetAmount,
    categorySpentTransaction: state => state.categorySpentTransaction,
    unCategorizedTransaction: state => state.unCategorizedTransaction,
    unCategorizedTransactions: state => state.unCategorizedTransactions,
    categoryForGroup: state => state.categoryForGroup,
    categoryForGroupWithoutUser: state => state.categoryForGroupWithoutUser,
    userRoleForTeam: state => state.userRoleForTeam,
    userSpentAmount: state => state.userSpentAmount,
    filterByName: state => state.filterByName,
    qbSyncStatus: state => state.qbSyncStatus,
    getCompanyAllTransactions: state => state.getCompanyAllTransactions,
    factorWiseSum: state => state.factorWiseSum,
    isDateRanges: state => state.isDateRanges,
    mapMerchantToCategory: state => state.mapMerchantToCategory,
    mapMerchantToCategorygroup: state => state.mapMerchantToCategorygroup,
    mapMerchantToCategorygroupTime: state => state.mapMerchantToCategorygroupTime,
    selectedTeams: state => state.selectedTeams,
    teamsForAllCompany: state => state.teamsForAllCompany,
    selectedALLTeams: state => state.selectedALLTeams,
    companyForAutoCategorization: state => state.companyForAutoCategorization,
    moveTransactions: state => state.moveTransactions,
    removeTransactions: state => state.removeTransactions,
    unCategorizeDashboard: state => state.unCategorizeDashboard,
    gotoCardData: state => state.gotoCardData,
    splitTransactionsSet: state => state.splitTransactionsSet,
    singleTransactions: state => state.singleTransactions,
    isAmountValid: state => state.isAmountValid,
    deletedTrans: state => state.deletedTrans,
    myInlineTransaction: state => state.myInlineTransaction,
    myDeleteTransaction: state => state.myDeleteTransaction,
    setTableColumn: state => state.setTableColumn,
    setTabName: state => state.setTabName,
    xlsFileUpload: state => state.xlsFileUpload,
    downloadXLSdata: state => state.downloadXLSdata,
    downloadXLSdataTeam: state => state.downloadXLSdataTeam,
    downloadXLSdataTag: state => state.downloadXLSdataTag,
    selectedTransactions: state => state.selectedTransactions,
    performBulkCategorizationRes: state => state.performBulkCategorizationRes,
    moveTransactionsHistory: state => state.moveTransactionsHistory,
    setNullValueTeam: state => state.setNullValueTeam,
    allUncategorize: state => state.allUncategorize,

    teamsForBulkCategorization: state => state.teamsForBulkCategorization,
  },
};
